import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "!flex-1" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("No report generated")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Generate on ???")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Type: ???")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Severities: ???")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Devices: ???")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Lang: ???")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Corporate: ???")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Annexes: ???")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" View ")

import { computed, Ref, PropType } from 'vue';
import { NkButton, NkDivider, NkGroup, NkIcon, NkStack, NkText } from '@/core/components';
import { InspectionGroup } from '@/entities/inspection-group/types';
import { useGetInspectionGroupQuery } from '@/entities/inspection-group/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionPDFDownload',
  props: {
  inspectionGroup: {
    type: Number as PropType<InspectionGroup['id']>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const inspectionGroupQueryData: Ref = computed(() => ({ id: props.inspectionGroup }));
const hasInspectionGroupQueryData = computed(() => !!inspectionGroupQueryData.value.id);
const { data: inspectionGroup } = useGetInspectionGroupQuery(inspectionGroupQueryData, {
  enabled: hasInspectionGroupQueryData,
});

const filepath = computed(() => `${process.env.VUE_APP_BACKEND_URL}/report/${inspectionGroup.value?.report}`)

const downloadPdf = () => {
    fetch(filepath.value)
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.href = url
            a.download = inspectionGroup.value?.report || 'default.pdf'

            a.click()

            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
        })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NkStack), { spacing: "8" }, {
    default: _withCtx(() => [
      _createVNode(_unref(NkGroup), {
        spacing: 2,
        "no-wrap": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(NkIcon), { name: "NkInfo" })
          ]),
          _createVNode(_unref(NkText), { type: "semibold-xxs-keep" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('inspection.form.pdf.download_infos')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(inspectionGroup)?.reportStatus !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(NkDivider)),
            _createVNode(_unref(NkGroup), { "no-wrap": "" }, {
              default: _withCtx(() => [
                _createVNode(_unref(NkText), { type: "semibold-xxs-keep-corpo" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(inspectionGroup)?.report), 1)
                  ]),
                  _: 1
                }),
                (_unref(inspectionGroup)?.reportStatus === 'DONE')
                  ? (_openBlock(), _createBlock(_unref(NkIcon), {
                      key: 0,
                      name: "NkCheckCircle"
                    }))
                  : _createCommentVNode("", true),
                (_unref(inspectionGroup)?.reportStatus === 'ON_GOING')
                  ? (_openBlock(), _createBlock(_unref(NkIcon), {
                      key: 1,
                      name: "NkUpdate"
                    }))
                  : _createCommentVNode("", true),
                (_unref(inspectionGroup)?.reportStatus === 'ERROR')
                  ? (_openBlock(), _createBlock(_unref(NkIcon), {
                      key: 2,
                      name: "NkClose"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "semibold-xxs-keep" }, {
              default: _withCtx(() => [
                _createTextVNode("Generate on " + _toDisplayString(_unref(inspectionGroup)?.reportGeneratedAt), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "caption-xxs" }, {
              default: _withCtx(() => [
                _createTextVNode("Type: " + _toDisplayString(_unref(inspectionGroup)?.reportMetadata.types), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "caption-xxs" }, {
              default: _withCtx(() => [
                _createTextVNode("Severities: " + _toDisplayString(_unref(inspectionGroup)?.reportMetadata.severities), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "caption-xxs" }, {
              default: _withCtx(() => [
                _createTextVNode("Devices: " + _toDisplayString(_unref(inspectionGroup)?.reportMetadata.devices), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "caption-xxs" }, {
              default: _withCtx(() => [
                _createTextVNode("Lang: " + _toDisplayString(_unref(inspectionGroup)?.reportMetadata.lang), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "caption-xxs" }, {
              default: _withCtx(() => [
                _createTextVNode("Corporate: " + _toDisplayString(_unref(inspectionGroup)?.reportMetadata.corporate ? 'Yes' : 'No'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "caption-xxs" }, {
              default: _withCtx(() => [
                _createTextVNode("Annexes: " + _toDisplayString(_unref(inspectionGroup)?.reportMetadata.annexes ? 'Yes' : 'No'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(NkDivider))
          ]))
        : _createCommentVNode("", true),
      (_unref(inspectionGroup)?.reportStatus === null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(NkDivider)),
            _createVNode(_unref(NkText), { type: "caption-xxs" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "semibold-xxs-keep" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "caption-xxs" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "caption-xxs" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "caption-xxs" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "caption-xxs" }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "caption-xxs" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_unref(NkText), { type: "caption-xxs" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_unref(NkDivider))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NkGroup), { position: "center" }, {
        default: _withCtx(() => [
          _createElementVNode("a", { onClick: downloadPdf }, [
            _createVNode(_unref(NkButton), {
              disabled: _unref(inspectionGroup)?.reportStatus !== 'DONE'
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("a", {
            href: _unref(filepath),
            target: "_blank",
            download: "test.pdf"
          }, [
            _createVNode(_unref(NkButton), {
              disabled: _unref(inspectionGroup)?.reportStatus !== 'DONE',
              type: "white-outline"
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["disabled"])
          ], 8, _hoisted_13)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})